import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "styled-components";
import { ReactNode } from "react";

type SummaryRowRTemplateProps = {
  date?: JSX.Element | string;
  transaction?: JSX.Element | string;
  client?: JSX.Element | string;
  cashIn?: JSX.Element | string;
  cashOut?: JSX.Element | string;
  details?: JSX.Element | string;
  children?: ReactNode;
};

export default function SummaryRowTemplate(props: SummaryRowRTemplateProps) {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id={`${props.transaction}_Header`}
      >
        <Summary>
          <Column>{props.date}</Column>
          <Column>{props.client}</Column>
          <Column>{props.transaction}</Column>
          <Column>{props.cashIn}</Column>
          <Column>{props.cashOut}</Column>
          <Column>{props.details}</Column>
        </Summary>
      </AccordionSummary>
      <AccordionDetails>{props.children}</AccordionDetails>
    </Accordion>
  );
}
const Column = styled.div<{ isIconPresent?: boolean }>`
  flex: 1;
  padding: ${(p) =>
    p.isIconPresent && p.isIconPresent === true
      ? "0 1em 0 0.75em "
      : "0 1em 0 1.75em"};
`;
const Summary = styled.div`
  display: flex;
  width: 100%;
`;
